// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#05456a"};